import React from "react";
import PageHeader from "@/components/PageHeader";
import { AgendaCalendar } from "@/components/AgendaCalendarDialog";
import { CalendarDays } from "lucide-react";
import FdpToScheduleCard from "@/components/FdpToScheduleCard";

/**
 * Cronograma — dedicated full-page view of the daily schedule.
 *
 * Uses AgendaCalendar inline (same component rendered inside the dialog
 * on the Dashboard) so the user has the full calendar UX without a
 * modal — ideal for planning multiple days from the desktop/sidebar.
 */
export default function Cronograma() {
  return (
    <div className="space-y-5 max-w-3xl pb-16" data-testid="cronograma-page">
      <PageHeader
        icon={CalendarDays}
        title="Cronograma"
        subtitle="Programe o dia, acompanhe status e materiais da equipe."
      />
      <FdpToScheduleCard />
      <AgendaCalendar />
    </div>
  );
}
